import { Link } from "react-router";
import OptimisedImage from "@components/OptimisedImage";
import { ImagePresets } from "@routes/Article/components/ArticleThumbnail/utils/enums";
import { Element } from "@typings/Cue";
import { CaaSImageFilters } from "@typings/OptimisedImage";

export type GalleryItemProps = {
  /** The title of the gallery item, will be displayed at gallery listing page. */
  title: string;
  /** The gallery items data used to display items at gallery listing page. */
  elements?: Element[];
  /** The link of the gallery item, will be displayed used to redirect to specific page. */
  link: string;
};

/**
 * Component to render SIA gallery item on gallery listing page
 */
const GalleryItem = ({ title, elements = [], link }: GalleryItemProps) => {
  const imageGallery = elements.find(({ type }) => type === "image_gallery");
  const firstChildId = imageGallery?.children?.[0];
  const firstImageUrl = firstChildId
    ? elements.find(({ id, type }) => id === firstChildId && type === "image")
        ?.relation?.fields?.["landscape-caas"]?.url
    : null;
  const imageFilters: CaaSImageFilters[] = [
    { w: ImagePresets.LARGE, dpr: 1, f: "webp" },
  ];

  return (
    <Link to={link} target="_blank">
      <div className="group relative cursor-pointer overflow-hidden bg-white shadow-sm">
        {firstImageUrl ? (
          <OptimisedImage
            src={firstImageUrl}
            alt={`${title} Awards Gallery`}
            className="h-full w-full object-cover"
            loading="lazy"
            filters={imageFilters}
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gray-200">
            <span className="text-gray-500">No Image Available</span>
          </div>
        )}

        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <h2 className="px-4 text-center font-public-sans text-lg font-semibold text-white hover:underline lg:text-4xl">
            {title}
          </h2>
        </div>
      </div>
    </Link>
  );
};

export default GalleryItem;
